import mitt from 'mitt'


//调用mitt

const mitter = mitt()

export default mitter